<template>
  <div class="buy-box">
    <div class="addr-box" v-if="info.addr && info.addr.cmobile">
      <i class="icon-addr"></i>
      <i class="icon-arror" @click="toSelectAddress"></i>
      <span>{{ info.addr.cname }}/{{ info.addr.cmobile }}</span>
      <span>{{ info.addr.daddr }}{{ info.addr.daddr2 }}</span>
    </div>
    <div class="no-addr-box" v-else @click="showAddAddress = true">
      <i></i>
      <span>添加收货人</span>
    </div>

    <span class="sub-title">付款方式</span>
    <div class="pay-type-box">
      <div @click="payMode = 0"><img src="https://xhdata.wan4.com/wsw-h5-wx-pay.png" /> <i
          :class="{ on: payMode == 0 }"></i></div>
      <div @click="payMode = 1"><img src="https://xhdata.wan4.com/wsw-h5-pay-ali.png" /> <i
          :class="{ on: payMode == 1 }"></i></div>
    </div>

    <div class="list-box">
      <div class="item-box" v-for="item, index in info.orderList" :key="index">
        <div class="company-title-box">
          <span>工厂{{ item.memCode }}</span>
        </div>
        <div class="goods-item" v-for="goods, gIndex in item.goodsList" :key="gIndex">
          <div class="sku-item" :class="{
            'sku-item-active': sku.opt,
            'sku-item-no-buttom-line': sku.opt && skuIndex < (goods.skuList.length - 1) && goods.skuList[skuIndex + 1].opt,
            'sku-item-no-top-line': sku.opt && skuIndex > 0 && goods.skuList[skuIndex - 1].opt
          }" v-for="sku, skuIndex in goods.skuList" :key="skuIndex">
            <i class="select sku-select" :class="{ 'select-on': sku.opt }" @click="optSku(sku)"></i>
            <div class="pic">
              <img v-lazy="sku.skuImgUrl + '?imageView2/1/w/120/h/120'" :key="sku.skuImgUrl" />
            </div>
            <span class="title overflow">{{ goods.goodsName }}</span>
            <span class="goods-code">【商品编号：{{ goods.goodsCode }}】</span>
            <span class="sku-info">{{ getSkuStr(sku) }}</span>
            <div class="price-box"><span class="price">{{ $fn.initPrice(sku.price, 0) }}<i>{{ $fn.initPrice(sku.price,
              1)
                  }}</i><i>元/个</i></span><span>x{{ Number(sku.buyQty ||
                    0).toLocaleString() }}</span>
            </div>
          </div>
        </div>
        <div class="count-box">
          <span class="count-ttl">数量合计：<i>{{ Number(item.ttlQty || 0).toLocaleString() }}</i></span>

          <span class="price-ttl"
            :data-car-fee="`(含运费: ${$fn.initPrice(item.carFee, 0)}${$fn.initPrice(item.carFee, 1)}元)`">金额总计：<i>{{
              $fn.initPrice(item.ttlAmt + item.carFee, 0) }}</i><i>{{ $fn.initPrice(item.ttlAmt + item.carFee, 1)
              }}元</i></span>

        </div>
      </div>
    </div>

    <div class="bottom-box">
      <span>应付金额：<i>{{ $fn.initPrice(info.grandTtl, 0) }}</i><i>{{ $fn.initPrice(info.grandTtl, 1) }}元</i></span>

      <van-button type="primary" @click="pay">立即支付</van-button>
    </div>

    <editAddressPopup v-model="showAddAddress" @onFinish="setAddress"></editAddressPopup>
  </div>
</template>
<script>
import editAddressPopup from '../../components/editAddressPopup.vue';
import { Toast } from 'vant';
export default {
  name: 'Buy',
  components: {
    editAddressPopup
  },
  props: {},
  data() {
    return {
      tempId: '',
      info: {},
      req: {},
      payMode: 0,//0:微信， 1支付宝
      showAddAddress: false,
    }
  },
  watch: {},
  created() {
    this.tempId = this.$route.query.cacheId;
    this.getData();
  },
  methods: {
    getData() {
      this.$ajax('/iap-api/wan4/base/getSelfDefinedDataCache.do', { tempId: this.tempId }).then(res => {
        this.info = res.data.res;
        this.req = res.data.req;
      })
    },
    getSkuStr(sku) {
      let arr = [];
      if (sku.colorText) {
        arr.push(sku.colorText)
      }
      if (sku.czText) {
        arr.push(sku.czText)
      }
      if (sku.sizeText) {
        if (sku.sizeText.indexOf("-∅") >= 0) {
          arr.push(sku.sizeText.slice(0, sku.sizeText.indexOf("-∅")))
        } else {
          arr.push(sku.sizeText)
        }
      }
      if (arr.length > 0) {
        return this.$fn.sliceJz(arr.join('；'))
      }
      return '-';
    },
    setAddress(e) {
      this.info.addr = e
      this.$ajax('/iap-api/wan4/base/setSelfDefinedDataCache.do', { tempId: this.tempId, myData: { res: this.info, req: this.req } })
    },
    toSelectAddress() {
      this.$router.push('/user/selectAddress?tempId=' + this.tempId)
    },
    pay() {
      if (!this.info.addr.cmobile) {
        this.showAddAddress = true;
        return
      }

      this.req.seq = this.info.addr.seq;
      const toast = Toast.loading({
        message: '支付中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner',
      });
      //直接购买
      if (this.info.previewMode == 1) {
        this.$ajax('/iap-api/wan4/order/orderConfirmPageData.do', this.req).then(res => {
          this.toPayPage(res.data.paymentSn, this.payMode, toast);
        }, () => {
          toast.clear()
        })
      }

      // 购物车购买
      if (this.info.previewMode == 0) {
        this.$ajax('/iap-api/wan4/presonal/cart/orderConfirmPageData4Cart.do', this.req).then(res => {
          this.toPayPage(res.data.paymentSn, this.payMode, toast);
        }, () => {
          toast.clear()
        })
      }
    },
    toPayPage(paymentSn, payMode, toast) {
      this.$ajax('/iap-api/wan4/order/orderPayment.do', { paymentSn: paymentSn, payMode: payMode }).then(() => {
        toast.clear()
        this.$router.replace(`/order/pay?paymentSn=${paymentSn}&payMode=${payMode}`)
      }, () => {
        toast.clear()
      })
    }
  },
}
</script>
<style lang="less" scoped>
.buy-box {
  display: flex;
  flex-direction: column;
  padding-bottom: 152px;

  .no-addr-box {
    height: 144px;
    margin: 18px 18px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 8px;

    >i {
      width: 58px;
      height: 58px;
      background: url('https://xhdata.wan4.com/wsw-h5-34.png') no-repeat center;
      background-size: 100%;
    }

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: bold;
      margin-left: 18px;
      line-height: 34px;
    }
  }

  .addr-box {
    margin: 18px 18px 0;
    display: flex;
    flex-direction: column;
    position: relative;
    background: #fff;
    border-radius: 8px;
    min-height: 144px;
    padding: 32px 90px 32px 106px;

    .icon-addr {
      width: 58px;
      height: 58px;
      background: url('https://xhdata.wan4.com/wsw-h5-35.png') no-repeat center;
      background-size: 100%;
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
    }

    .icon-arror {
      height: 100%;
      width: 86px;
      background: url('https://xhdata.wan4.com/wsw-h5-36.png') no-repeat center;
      background-size: 38px 38px;
      position: absolute;
      right: 0;
      top: 0;
    }

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: bold;
      line-height: 34px;
    }

    >span+span {
      color: #333;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 12px;
    }

  }

  .sub-title {
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: bold;
    line-height: 44px;
    margin: 20px 18px 0;
  }

  .pay-type-box {
    margin: 18px 18px 0;
    display: flex;

    >div {
      flex: 1;
      height: 100px;
      display: flex;
      background: #fff;
      padding: 0 24px;
      border-radius: 8px;
      align-items: center;

      &:first-child {
        margin-right: 14px;
      }

      >img {
        height: 36px;
      }

      >i {
        width: 32px;
        height: 32px;
        border: 2px solid #999;
        margin-left: auto;
        border-radius: 32px;
      }

      .on {
        width: 32px;
        height: 32px;
        margin-left: auto;
        background: url('https://xhdata.wan4.com/wsw-h5-21.png') no-repeat center;
        background-size: 32px;
        border-radius: 32px;
        border: 2px solid #ff6634;
        overflow: hidden;
      }
    }
  }


  .bottom-box {
    position: fixed;
    height: calc(env(safe-area-inset-bottom) + 120px);
    padding-bottom: calc(env(safe-area-inset-bottom));
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #DCDCDC;
    background: #FFF;
    display: flex;
    padding: 0 24px;

    >span {
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 22px;
      position: relative;
      margin: 22px 0 auto;

      &::after {
        position: absolute;
        content: '(含运费)';
        top: 100%;
        left: 0;
        color: #999;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
      }

      >i {
        color: #F53F3F;
        font-size: 32px;
        font-style: normal;
        font-weight: bold;
        line-height: 44px;
      }

      >i+i {
        color: #F53F3F;
        font-size: 24px;
        font-style: normal;
        font-weight: bold;
        line-height: 34px;
      }
    }

    .van-button {
      width: 220px;
      height: 86px;
      border-radius: 8px;
      margin-top: 18px;
      margin-left: auto;
    }
  }

  .list-box {
    display: flex;
    flex-direction: column;

    >* {
      flex-shrink: 0;
    }

    .item-box {
      margin: 20px 18px 0;
      background: #fff;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;

      &:last-child {
        margin-bottom: 0;
      }

      .company-title-box {
        height: 76px;
        border-bottom: 1px solid #E5E5E5;
        display: flex;
        align-items: center;
        padding-left: 24px;

        >span {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          display: flex;
          align-items: center;

        }
      }

      .count-box {
        display: flex;
        flex-direction: column;
        border-radius: 0px 0px 8px 8px;
        border-top: 1px solid #E5E5E5;
        height: 114px;
        background: linear-gradient(90deg, #FFFFFF80 68%, #FFD1C280 100%);
        padding: 0 24px;
        position: relative;
        align-items: end;
        margin-top: 32px;

        .count-ttl {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
          position: absolute;
          left: 24px;
          top: 29px;


          >i {
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: bold;
            line-height: 34px;
          }
        }

        .price-ttl {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
          margin-top: 18px;
          position: relative;

          &::after {
            content: attr(data-car-fee);
            position: absolute;
            left: 0;
            top: 100%;
            color: #999;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
          }

          >i {
            color: #F53F3F;
            font-size: 32px;
            font-style: normal;
            font-weight: bold;
            line-height: 44px;
          }

          >i+i {
            color: #f53f3f;
            font-size: 24px;
            font-style: normal;
            font-weight: bold;
            line-height: 34px;
          }
        }
      }

      .goods-item {
        background: #F4F4F4;
        display: flex;
        flex-direction: column;
        margin: 24px 24px 0;
        border-radius: 4px;

        .sku-item {
          display: flex;
          flex-direction: column;
          border-radius: 4px;
          border: 1px solid #F4F4F4;
          padding: 32px 24px 32px 160px;
          position: relative;

          &-active {
            background: #FFF7E8;
            border: 1px solid #FF6634;
            z-index: 1;

            &::after {
              content: none !important;
            }
          }

          &-no-buttom-line {
            border-bottom: 1px solid #FFF7E8 !important;
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
          }

          &-no-top-line {
            border-top: 1px solid #FFF7E8 !important;
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;

            &::after {
              content: '' !important;
              background: #FF6634 !important;
            }
          }

          &::after {
            content: '';
            position: absolute;
            height: 1px;
            left: 24px;
            right: 24px;
            top: -3px;
            background: #DCDCDC;
          }

          &:first-child {
            padding-top: 24px;

            &::after {
              content: none;
            }
          }

          &-active {
            border: 1px solid #FF6634;
            background: #FFF7E8;
          }

          .sku-select {
            position: absolute;
            top: 65px;
            left: 12px;
          }

          .pic {
            position: absolute;
            border-radius: 4px;
            border: 2px solid #DCDCDC;
            width: 120px;
            height: 120px;
            top: 24px;
            left: 24px;
            overflow: hidden;

            >img {
              width: 100%;
              height: 100%;
            }

            >span {
              width: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 38px;
              border-radius: 0px 0px 4px 4px;
              background: #00000099;
              color: #FFF;
              font-size: 24px;
              text-align: center;
              line-height: 38px;
            }
          }

          .title {
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 34px;
          }

          .goods-code {
            color: #666;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 34px;
            margin-top: 6px;
          }

          .sku-info {
            border-radius: 2px;
            background: #FFF;
            padding: 12px 18px;
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 34px;
            margin-top: 12px;
            word-break: break-all;
          }

          .price-box {
            display: flex;
            margin-top: 12px;

            .price {
              color: #F53F3F;
              font-family: Arial;
              font-size: 34px;
              font-style: normal;
              font-weight: 700;
              line-height: 34px;

              >i {
                color: #F53F3F;
                font-family: Arial;
                font-size: 24px;
                font-style: normal;
                font-weight: 700;
                line-height: 34px;
              }

              >i+i {
                color: #F53F3F;
                font-family: "PingFang SC";
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                line-height: 34px;
              }
            }

            >span+span {
              color: #333;
              font-family: Arial;
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 34px;
              margin-left: auto;
            }
          }
        }

      }

    }
  }
}
</style>